<div class="numero_piezas">{{ numeroSolicitudes }}</div>
<div class="descripcion">Diseños digitales</div>
